(function(){ 'use strict';

var THRESHOLDS = {
  AUD: { cents: 15000, sym: '$' },
  USD: { cents: 12000, sym: '$' },
  EUR: { cents: 10000, sym: '\u20ac' },
  GBP: { cents: 8500,  sym: '\u00a3' },
  CAD: { cents: 16000, sym: '$' }
};
var DEFAULT_THRESHOLD = { cents: 17000, sym: '$' }; // $170 AUD — all other currencies
var SHIPPING_FROM_RATES = {
  AUD: 1000,
  USD: 1000,
  EUR: 900,
  GBP: 800,
  CAD: 1400
};
var DEFAULT_SHIPPING_FROM = 1500;
var TRUST_LINES = {
  USD: ['FAST TRACKED USA SHIPPING INCLUDED', "NO-STRESS EXCHANGES IF THE FIT ISN'T PERFECT ✨", 'DUTIES & TAXES INCLUDED — PAY NOTHING ELSE'],
  AUD: ['FAST, FREE SHIPPING INCLUDED', "NO-STRESS EXCHANGES IF THE FIT ISN'T PERFECT ✨"],
  EUR: ['FAST TRACKED EU SHIPPING INCLUDED', "NO-STRESS EXCHANGES IF THE FIT ISN'T PERFECT ✨", 'DUTIES & TAXES INCLUDED — PAY NOTHING ELSE'],
  GBP: ['FAST TRACKED UK SHIPPING INCLUDED', "NO-STRESS EXCHANGES IF THE FIT ISN'T PERFECT ✨", 'DUTIES & TAXES INCLUDED — PAY NOTHING ELSE'],
  CAD: ['FAST TRACKED CANADA SHIPPING INCLUDED', "NO-STRESS EXCHANGES IF THE FIT ISN'T PERFECT ✨", 'DUTIES & TAXES INCLUDED — PAY NOTHING ELSE']
};
var DEFAULT_TRUST = ['FAST TRACKED SHIPPING INCLUDED', "NO-STRESS EXCHANGES IF THE FIT ISN'T PERFECT ✨", 'DUTIES & TAXES INCLUDED — PAY NOTHING ELSE'];
var CHECKOUT_LINES = {};
var DEFAULT_CHECKOUT_LINE = 'THE HARDEST PART WAS CHOOSING 🖤 YOUR FAVOURITES WON\'T WAIT';
var LOYALTY_API = 'https://openclaw-2und.srv1531291.hstgr.cloud/api/loyalty/customer';
var LOYALTY_REDEEM = 'https://openclaw-2und.srv1531291.hstgr.cloud/api/loyalty/redeem';
var TIER_ICONS = { it_girl: '\u2726', main_character: '\u2726\u2726', icon: '\u2726\u2726\u2726' };
var PRIORITY_VARIANT_ID = 43153007968441;
var PRIORITY_PRICES = {
  AUD: { cents: 1000, display: '$10.00' },
  USD: { cents: 1100, display: '$11.00' },
  EUR: { cents: 895,  display: '€8.95' },
  GBP: { cents: 800,  display: '£8.00' },
};
var PRIORITY_DEFAULT = { cents: 1000, display: '$10.00' };
var PROTECTION_VARIANT_ID = 48613589647545;
var PROTECTION_PRICES = {
  AUD: { cents: 500, display: '$5.00' },
  USD: { cents: 500, display: '$5.00' },
  EUR: { cents: 500, display: '\u20ac5.00' },
  GBP: { cents: 500, display: '\u00a35.00' },
  CAD: { cents: 500, display: '$5.00' }
};
var PROTECTION_DEFAULT = { cents: 500, display: '$5.00' };
var EXPRESS_AU_VARIANT_ID = 49028764467385;
var EXPRESS_INTL_VARIANT_ID = 49028805165241;
var EXPRESS_PRICES = {
  AUD: { cents: 1000, display: '$10.00' },
  USD: { cents: 1000, display: '$10.00' },
  EUR: { cents: 900, display: '€9.00' },
  GBP: { cents: 800, display: '£8.00' },
  CAD: { cents: 1400, display: '$14.00' }
};
var EXPRESS_DEFAULT_PRICE = { cents: 1400, display: '$14.00' };
var CART_OFFERS_DISMISSED_KEY = 'alohrCartOffersDismissed';
var CART_OFFERS_SHOWN_KEY = 'alohrCartOffersShown';
var CART_RECS_DEFAULT_LIMIT = 20;
var FLASH_SALE_MULTIPLIER = 0.8; // 20% off for cart offers display
var LAST_CHANCE_PRODUCTS = [
  {
    id: 7255184703673,
    title: 'Indulge Midi Bike Shorts Storm',
    handle: 'indulge-midi-bike-shorts-storm',
    image: 'https://cdn.shopify.com/s/files/1/0587/6590/2009/files/DSC003562.jpg?v=1733836791',
    price: null,
    url: '/products/indulge-midi-bike-shorts-storm'
  },
  {
    id: 7253080178873,
    title: 'Indulge Strappy Crop Ivory',
    handle: 'indulge-strappy-crop-ivory',
    image: 'https://cdn.shopify.com/s/files/1/0587/6590/2009/files/DSC011622.jpg?v=1733836857',
    price: null,
    url: '/products/indulge-strappy-crop-ivory'
  },
  {
    id: 7255160750265,
    title: 'Indulge Staple Full Length Tights Jade',
    handle: 'indulge-full-length-tights-jade',
    image: 'https://cdn.shopify.com/s/files/1/0587/6590/2009/files/DSC005023_b9ecced6-ca04-4dac-9e99-781e79cbb6c4.jpg?v=1733836840',
    price: null,
    url: '/products/indulge-full-length-tights-jade'
  },
  {
    id: 7249811538105,
    title: 'Workout Towel Day & Night',
    handle: 'workout-towel-day-night',
    image: 'https://cdn.shopify.com/s/files/1/0587/6590/2009/products/DSC08662.jpg?v=1733836877',
    price: null,
    url: '/products/workout-towel-day-night'
  },
  {
    id: 7568545579193,
    title: 'Indulge High Rise Full Length Tights Sapphire',
    handle: 'indulge-high-rise-full-length-tights-sapphire',
    image: 'https://cdn.shopify.com/s/files/1/0587/6590/2009/files/IMG_1542.jpg?v=1743490297',
    price: null,
    url: '/products/indulge-high-rise-full-length-tights-sapphire'
  }
];

/* ── Helpers ── */

function $(s) { return document.querySelector(s); }
function $$(s) { return Array.from(document.querySelectorAll(s)); }

function esc(s) {
  var d = document.createElement('div');
  d.textContent = s;
  return d.innerHTML;
}

function soldToday(productId) {
  var day = new Date().toISOString().slice(0, 10);
  var seed = 0;
  var str = day + '-' + productId;
  for (var i = 0; i < str.length; i++) {
    seed = ((seed << 5) - seed + str.charCodeAt(i)) | 0;
    seed = (seed ^ (seed >>> 16)) * 0x45d9f3b | 0;
  }
  return 17 + (Math.abs(seed) % 34);
}

function sized(url, size) {
  var src = (typeof url === 'string') ? url : (url && url.src ? url.src : '');
  if (!src) return '';
  return src.replace(/(\.[a-z]+)(\?|$)/, '_' + size + 'x$1$2');
}

function fmt(cents, currency) {
  var t = THRESHOLDS[currency] || DEFAULT_THRESHOLD;
  return t.sym + (cents / 100).toFixed(2);
}

function parsePrice(p) {
  var s = String(p);
  if (s.indexOf('.') !== -1 || parseFloat(s) < 1000) {
    return Math.round(parseFloat(s) * 100);
  }
  return parseInt(s, 10);
}

function flashPrice(cents) {
  if (typeof cents !== 'number' || isNaN(cents)) return cents;
  return Math.max(0, Math.round(cents * FLASH_SALE_MULTIPLIER));
}

/* ── Offer Variant Picker (Popup) ── */

var _offerProductCache = {};

function loadOfferProduct(handle) {
  if (!handle) return Promise.reject(new Error('Missing handle'));
  if (_offerProductCache[handle]) return Promise.resolve(_offerProductCache[handle]);
  return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
    .then(function(r){ return r.json(); })
    .then(function(prod){
      _offerProductCache[handle] = prod;
      return prod;
    });
}

function offerVariantsFromProduct(prod) {
  var vars = (prod && prod.variants) ? prod.variants : [];
  return vars.map(function(v) {
    return {
      id: v.id,
      title: v.public_title || v.title,
      available: v.available !== false,
      price: v.price,
      compare_at_price: v.compare_at_price
    };
  });
}

function offerHasRealVariants(variants) {
  return variants && variants.length > 1 && variants[0] && variants[0].title !== 'Default Title';
}

function setOfferCardPrice(card, currency, priceCents, compareCents) {
  try {
    var wrap = card && card.querySelector && card.querySelector('[data-offer-price]');
    if (!wrap) return;
    var now = wrap.querySelector('[data-offer-price-now]');
    var discounted = flashPrice(priceCents);
    if (now && typeof discounted === 'number') now.textContent = fmt(discounted, currency);

    var wasBase = (typeof compareCents === 'number' && typeof priceCents === 'number' && compareCents > priceCents) ? compareCents : null;
    var shouldShowWas = typeof discounted === 'number' && typeof wasBase === 'number' && wasBase > discounted;
    var was = wrap.querySelector('[data-offer-price-was]');
    if (shouldShowWas) {
      if (!was) {
        was = document.createElement('span');
        was.className = 'alohr-cart-offer__price-was';
        was.setAttribute('data-offer-price-was', '');
        wrap.appendChild(was);
      }
      was.textContent = fmt(wasBase, currency);
      was.style.display = '';
    } else if (was) {
      was.style.display = 'none';
    }
  } catch(e) {}
}

function primeOfferVariantPickers() {
  var overlay = document.getElementById('alohr-cart-offers-overlay');
  if (!overlay) return;
  var currency = (cart && cart.currency) ? cart.currency : 'USD';
  overlay.querySelectorAll('[data-cart-offer-card]').forEach(function(card) {
    var handle = (card.dataset && card.dataset.offerHandle) ? card.dataset.offerHandle : '';
    var picker = card.querySelector('[data-offer-size-picker]');
    var sizesEl = card.querySelector('[data-offer-sizes]');
    var addBtn = card.querySelector('[data-cart-offer-add]');
    if (!handle || !picker || !sizesEl || !addBtn) return;

    loadOfferProduct(handle)
      .then(function(prod) {
        var variants = offerVariantsFromProduct(prod).filter(function(v){ return v && v.available && v.id; });
        if (!offerHasRealVariants(variants)) {
          card.dataset.requiresSize = '0';
          picker.style.display = 'none';
          addBtn.disabled = false;
          if (variants[0] && typeof variants[0].price === 'number') {
            setOfferCardPrice(card, currency, variants[0].price, (typeof variants[0].compare_at_price === 'number') ? variants[0].compare_at_price : null);
          }
          return;
        }

        card.dataset.requiresSize = '1';
        addBtn.disabled = true;
        addBtn.textContent = (window.alohrCartStrings&&window.alohrCartStrings.addToBag||'ADD TO BAG');

        sizesEl.innerHTML = variants.map(function(v) {
          return '<button type="button" class="alohr-cart-offer__size-pill" data-offer-pick-size data-vid="' + v.id + '"' +
            (typeof v.price === 'number' ? (' data-price="' + v.price + '"') : '') +
            (typeof v.compare_at_price === 'number' ? (' data-compare-at-price="' + v.compare_at_price + '"') : '') +
            '>' + esc(v.title) + '</button>';
        }).join('');

        picker.style.display = 'block';

        card.dataset.selectedVid = '';
        sizesEl.querySelectorAll('[data-offer-pick-size]').forEach(function(b){ b.classList.remove('is-selected'); });
        if (variants[0] && typeof variants[0].price === 'number') {
          setOfferCardPrice(card, currency, variants[0].price, (typeof variants[0].compare_at_price === 'number') ? variants[0].compare_at_price : null);
        }
      })
      .catch(function() {});
  });
}

/* �����������������������─ State ── */

var cart = null;
var igcLoaded = false;
var priorityKey = null;

/* ── Cart API ── */

function fetchCart() {
  return fetch('/cart.js', { credentials: 'same-origin' })
    .then(function(r){ return r.json(); })
    .then(function(c){ cart = c; return c; });
}

function updateItem(key, qty) {
  return fetch('/cart/change.js', {
    method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).then(function(r){ return r.json(); })
    .then(function(){ return fetchCart().then(render); });
}

function addItem(vid, qty) {
  return fetch('/cart/add.js', {
    method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: vid, quantity: qty || 1 }] })
  }).then(function(r){ return r.json(); })
    .then(function(){ return fetchCart().then(render); });
}

/* ── Open / Close ── */

function cartOffersShown() {
  try {
    return window.sessionStorage && sessionStorage.getItem(CART_OFFERS_SHOWN_KEY) === '1';
  } catch(e) {
    return false;
  }
}

function setCartOffersShown() {
  try {
    if (window.sessionStorage) sessionStorage.setItem(CART_OFFERS_SHOWN_KEY, '1');
  } catch(e) {}
}

function cartOffersDismissed() {
  try {
    return window.sessionStorage && sessionStorage.getItem(CART_OFFERS_DISMISSED_KEY) === '1';
  } catch(e) {
    return false;
  }
}

function setCartOffersDismissed() {
  try {
    if (window.sessionStorage) sessionStorage.setItem(CART_OFFERS_DISMISSED_KEY, '1');
  } catch(e) {}
}

function hasCartOffers() {
  return !!document.querySelector('#alohr-cart-offers-overlay [data-cart-offer-add]');
}

function shouldShowCartOffers(options) {
  options = options || {};
  if (options === 'add-to-cart') options = { source: 'add-to-cart' };
  return (options.source === 'add-to-cart' || options.showCartOffers === true)
    && !cartOffersShown()
    && !cartOffersDismissed()
    && hasCartOffers();
}

function openCartOffers() {
  var overlay = document.getElementById('alohr-cart-offers-overlay');
  if (!overlay || !hasCartOffers() || cartOffersDismissed()) return;
  overlay.classList.add('is-open');
  overlay.setAttribute('aria-hidden', 'false');
  setTimeout(primeOfferVariantPickers, 0);
}

function closeCartOffers(persistDismissal) {
  var overlay = document.getElementById('alohr-cart-offers-overlay');
  if (persistDismissal) setCartOffersDismissed();
  if (!overlay) return;
  overlay.classList.remove('is-open');
  overlay.setAttribute('aria-hidden', 'true');
}

function openCart(options) {
  igcLoaded = false;
  var showOffers = shouldShowCartOffers(options);
  fetchCart().then(function(c) {
    render(c);
    if (showOffers && c.items && c.items.length) {
      setCartOffersShown();
      setTimeout(openCartOffers, 80);
    }
  });
  document.getElementById('alohr-cart-drawer').classList.add('is-open');
  document.getElementById('alohr-cart-backdrop').classList.add('is-open');
  document.body.style.overflow = 'hidden';

  // Auto-expand IGC for logged-in members
  var igcWidget = document.getElementById('igc-widget');
  if (igcWidget && igcWidget.dataset.email) {
    AlohrCart.toggleIGC(true);
  }
}

function closeCart() {
  closeCartOffers(false);
  document.getElementById('alohr-cart-drawer').classList.remove('is-open');
  document.getElementById('alohr-cart-backdrop').classList.remove('is-open');
  document.body.style.overflow = '';
}

/* ── Badge ── */

function updateBadge(count) {
  $$('.cart-count, .js-cart-count, [data-cart-count]').forEach(function(el) {
    el.textContent = count;
    if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', count);
  });
}

/* ── Shipping Bar ── */

function updateShipping(c) {
  var bar = document.getElementById('alohr-shipping-fill');
  var msg = document.getElementById('alohr-shipping-text');
  var icon = document.getElementById('alohr-shipping-icon');
  var progressIcon = document.getElementById('alohr-shipping-progress-icon');
  var section = document.getElementById('alohr-shipping-bar');
  if (!bar || !msg) return;

  var t = THRESHOLDS[c.currency] || DEFAULT_THRESHOLD;
  var subtotal = c.total_price;
  // Correct for priority/protection price quirks
  var _priItem = c.items && c.items.find(function(i){ return i.variant_id == PRIORITY_VARIANT_ID; });
  if (_priItem) { subtotal = subtotal - _priItem.line_price + (PRIORITY_PRICES[c.currency] || PRIORITY_DEFAULT).cents; }
  var _proItem = c.items && c.items.find(function(i){ return String(i.variant_id) === String(PROTECTION_VARIANT_ID); });
  if (_proItem) { subtotal = subtotal - _proItem.line_price + (PROTECTION_PRICES[c.currency] || PROTECTION_DEFAULT).cents; }
  var _expItemBar = c.items && c.items.find(function(i){ return String(i.variant_id) === String(EXPRESS_AU_VARIANT_ID) || String(i.variant_id) === String(EXPRESS_INTL_VARIANT_ID); });
  if (_expItemBar) { subtotal = subtotal - _expItemBar.line_price; }
  var pct = Math.min(100, Math.max(0, Math.round((subtotal / t.cents) * 100)));

  if (subtotal >= t.cents) {
    msg.innerHTML = (window.alohrCartStrings&&window.alohrCartStrings.freeShippingUnlocked||'🎉 FREE SHIPPING UNLOCKED');
    bar.style.width = '100%';
    if (icon) icon.style.display = 'none';
    if (progressIcon) progressIcon.style.display = 'flex';
    if (section) section.classList.add('is-unlocked');
  } else {
    var remaining = t.cents - subtotal;
    msg.innerHTML = (window.alohrCartStrings&&window.alohrCartStrings.spendMore||'SPEND {amount} MORE FOR FREE SHIPPING').replace('{amount}','<strong>'+fmt(remaining,c.currency)+'</strong>');
    bar.style.width = pct + '%';
    if (icon) icon.style.display = 'none';
    if (progressIcon) progressIcon.style.display = pct > 2 ? 'flex' : 'none';
    if (section) section.classList.remove('is-unlocked');
  }
}

/* ── Trust Lines ── */

function updateTrustLines(c) {
  var container = document.getElementById('alohr-trust-lines');
  var footerEl = document.getElementById('alohr-checkout-line');
  if (!container) return;
  container.innerHTML = '';
  if (footerEl) footerEl.textContent = '';
}

/* ── Points Earn Preview ── */

function updatePointsEarn(c) {
  try {
    var row = document.getElementById('alohr-points-earn');
    var txt = document.getElementById('alohr-points-earn-text');
    if (!row || !txt) return;

    var priorityItemEarn = c.items && c.items.find(function(i){ return i.variant_id == PRIORITY_VARIANT_ID; });
    var displayTotal = c.total_price;
    if (priorityItemEarn) {
      var pp = PRIORITY_PRICES[c.currency] || PRIORITY_DEFAULT;
      displayTotal = displayTotal - priorityItemEarn.line_price + pp.cents;
    }
    var pts = Math.floor(displayTotal / 100);
    var baseEarnValue = Math.round(pts * 7.5); // Base tier: 100 pts = $7.50

    if (!c.items.length || pts <= 0 || baseEarnValue <= 0) {
      row.classList.add('is-hidden');
      return;
    }
    row.classList.remove('is-hidden');
    txt.innerHTML = '<span class="alohr-points-earn__main">PLUS EARN <span class="alohr-points-earn__amount">' + fmt(baseEarnValue, c.currency) + '</span> IN CREDIT ON THIS ORDER</span>'
      + '<span class="alohr-points-earn__sub">Your next order will be even cheaper \uD83D\uDDA4</span>';
  } catch(e) {}
}

/* ── Render Items ���─ */

function renderItems(c) {
  var container = document.getElementById('alohr-cart-items');
  if (!container) return;

  var cartDiscounts = c.cart_level_discount_applications || [];
  var cartDiscountRate = 0;
  if (cartDiscounts.length > 0 && c.items_subtotal_price > 0) {
    cartDiscountRate = (c.items_subtotal_price - c.total_price) / c.items_subtotal_price;
  }

  var html = '';
  c.items.forEach(function(item) {
    if (item.variant_id == PRIORITY_VARIANT_ID) return;
    if (String(item.variant_id) === String(PROTECTION_VARIANT_ID)) return;
    if (String(item.variant_id) === String(EXPRESS_AU_VARIANT_ID)) return;
    if (String(item.variant_id) === String(EXPRESS_INTL_VARIANT_ID)) return;

    var img = item.image ? sized(item.image, 280) : '';
    var title = esc(item.product_title || item.title);
    var variant = item.variant_title ? esc(item.variant_title) : '';

    var origUnit = item.original_line_price;
    var finalUnit = item.final_line_price;

    var hasLineDiscount = item.original_line_price > item.final_line_price;
    var hasCartDiscount = !hasLineDiscount && cartDiscountRate > 0;

    var discountLabel = '';
    if (hasLineDiscount) {
      discountLabel = '20% OFF DISCOUNT APPLIED';
    }

    if (hasCartDiscount) {
      finalUnit = Math.round(origUnit * (1 - cartDiscountRate));
      discountLabel = '20% OFF DISCOUNT APPLIED';
    }

    var showDiscount = hasLineDiscount || hasCartDiscount;

    html += '<div class="alohr-cart-item">';
    var productUrl = item.url || ('/products/' + (item.handle || ''));
    html += '<div class="alohr-cart-item__img">';
    if (img) html += '<a href="' + productUrl + '" onclick="AlohrCart.close()"><img src="' + img + '" alt="' + title + '" loading="lazy"></a>';
    html += '</div>';
    html += '<div class="alohr-cart-item__info">';
    html += '<div class="alohr-cart-item__top">';
    html += '<a href="' + productUrl + '" class="alohr-cart-item__title-link" onclick="AlohrCart.close()">' + title + '</a>';
    html += '<button class="alohr-cart-item__remove" data-action="remove" data-key="' + item.key + '" data-qty="0" aria-label="Remove">&times;</button>';
    html += '</div>';
    if (variant) html += '<span class="alohr-cart-item__variant-pill">Size: ' + variant + '</span>';
    html += '<div class="alohr-cart-item__price-row">';
    html += '<div class="alohr-cart-item__prices">';
    if (showDiscount) {
      html += '<span class="alohr-cart-item__price-original">' + fmt(origUnit, c.currency) + '</span> ';
    }
    html += '<span class="alohr-cart-item__price">' + fmt(showDiscount ? finalUnit : origUnit, c.currency) + '</span>';
    html += '</div>';
    html += '<div class="alohr-cart-item__qty-controls">';
    html += '<button data-action="decrease" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>';
    html += '<span>' + item.quantity + '</span>';
    html += '<button data-action="increase" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>';
    html += '</div>';
    html += '</div>';
    html += '</div>';
    html += '</div>';
  });

  container.innerHTML = html;
}

/* ── Render Summary ── */

/* ── Working-day date calculator ── */
function addWorkingDays(date, days) {
  var result = new Date(date);
  var added = 0;
  while (added < days) {
    result.setDate(result.getDate() + 1);
    var dow = result.getDay();
    if (dow !== 0 && dow !== 6) added++;
  }
  return result;
}

function formatDeliveryDate(d) {
  var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return days[d.getDay()] + ', ' + d.getDate() + ' ' + months[d.getMonth()];
}

function deliveryRange(minDays, maxDays) {
  var now = new Date();
  var dow = now.getDay();
  var todayIsWorkday = (dow !== 0 && dow !== 6);
  if (todayIsWorkday) { minDays = minDays - 1; maxDays = maxDays - 1; }
  return formatDeliveryDate(addWorkingDays(now, minDays)) + ' – ' + formatDeliveryDate(addWorkingDays(now, maxDays));
}

function hasPreOrder(c) {
  if (!c || !c.items) return false;
  var keywords = ['pre-order', 'preorder', 'pre order', 'coming soon'];
  return c.items.some(function(item) {
    var title = ((item.product_title || '') + ' ' + (item.title || '')).toLowerCase();
    return keywords.some(function(kw) { return title.indexOf(kw) >= 0; });
  });
}

/* v2 ── Render Delivery Estimate + Express Upsell ── */
function renderDelivery(c) {
  var block = document.getElementById('alohr-delivery');
  if (!block) return;

  if (hasPreOrder(c) || !c.items || !c.items.length) {
    block.style.display = 'none';
    return;
  }

  var isAU = c.currency === 'AUD';
  var expressVariantId = isAU ? EXPRESS_AU_VARIANT_ID : EXPRESS_INTL_VARIANT_ID;
  var otherExpressId = isAU ? EXPRESS_INTL_VARIANT_ID : EXPRESS_AU_VARIANT_ID;
  var expressItem = c.items.find(function(i) { return String(i.variant_id) === String(expressVariantId); });
  var expressInCart = !!expressItem;
  var otherExpressItem = c.items.find(function(i) { return String(i.variant_id) === String(otherExpressId); });
  var otherExpressInCart = !!otherExpressItem;

  var stdMin = isAU ? 3 : 5;
  var stdMax = isAU ? 5 : 10;
  var expMin = isAU ? 2 : 4;
  var expMax = isAU ? 3 : 6;

  var datesEl = document.getElementById('alohr-delivery-dates');
  if (datesEl) {
    datesEl.textContent = deliveryRange(stdMin, stdMax);
  }

  block.style.display = 'block';

  // Threshold calc (exclude express + priority quirk)
  var t = THRESHOLDS[c.currency] || DEFAULT_THRESHOLD;
  var expressTotal = c.total_price;
  var priorityItem = c.items.find(function(i){ return i.variant_id == PRIORITY_VARIANT_ID; });
  if (priorityItem) {
    expressTotal = expressTotal - priorityItem.line_price + (PRIORITY_PRICES[c.currency] || PRIORITY_DEFAULT).cents;
  }
  if (expressItem) { expressTotal = expressTotal - expressItem.line_price; }
  if (otherExpressItem) { expressTotal = expressTotal - otherExpressItem.line_price; }

  var shippingUnlocked = expressTotal >= t.cents;
  var expressBlock = document.getElementById('alohr-delivery-express');
  if (expressBlock) {
    var realItems = c.items.filter(function(i) {
      return i.variant_id != PRIORITY_VARIANT_ID
        && String(i.variant_id) !== String(EXPRESS_AU_VARIANT_ID)
        && String(i.variant_id) !== String(EXPRESS_INTL_VARIANT_ID);
    });
    expressBlock.style.display = (shippingUnlocked && realItems.length > 0) ? 'block' : 'none';
  }

    var expDatesEl = document.getElementById('alohr-express-dates');
  if (expDatesEl) {
    expDatesEl.textContent = '';
  }

}

/* ── Discover Our Favourites ── */
var DISCOVER_FAVOURITES = [
  {
    key: 'swimwear',
    label: 'Swimwear',
    cta: 'EXPLORE SWIM',
    url: 'https://www.alohra.com.au/collections/all-swimwear',
    image: 'https://cdn.shopify.com/s/files/1/0587/6590/2009/files/08338C69-7515-4921-BB98-E2279EE83119.jpg?v=1788340351'
  },
  {
    key: 'loungewear',
    label: 'Loungewear',
    cta: 'EXPLORE LOUNGE',
    url: 'https://www.alohra.com.au/collections/deluxe-blanket-hoodie',
    image: 'https://cdn.shopify.com/s/files/1/0587/6590/2009/files/FinalStripePrint-206.jpg?v=1781545234'
  },
  {
    key: 'outerwear',
    label: 'Outerwear',
    cta: 'EXPLORE OUTERWEAR',
    url: 'https://www.alohra.com.au/collections/all-outerwear',
    image: 'https://cdn.shopify.com/s/files/1/0587/6590/2009/files/FinalStripePrint-71.jpg?v=1778417531'
  },
  {
    key: 'activewear',
    label: 'Activewear',
    cta: 'EXPLORE ACTIVE',
    url: 'https://www.alohra.com.au/collections/all-activewear',
    image: 'https://cdn.shopify.com/s/files/1/0587/6590/2009/files/DSC010027.jpg?v=1733836812'
  }
];

function detectDiscoverCategory(item) {
  var txt = [
    item.product_title,
    item.title,
    item.product_type,
    item.vendor,
    item.url,
    item.handle
  ].filter(Boolean).join(' ').toLowerCase();

  if (!txt) return '';
  if (String(item.variant_id) === String(PROTECTION_VARIANT_ID)
    || String(item.variant_id) === String(PRIORITY_VARIANT_ID)
    || String(item.variant_id) === String(EXPRESS_AU_VARIANT_ID)
    || String(item.variant_id) === String(EXPRESS_INTL_VARIANT_ID)) {
    return '';
  }

  if (/(bikini|swim|one piece|one-piece|margot|alba|lucia|cleo|isla|esme|paloma|frankie|kendall|solana|harper|luna|norah|ivy|bronte|maia|tatum)/.test(txt)) {
    return 'swimwear';
  }
  if (/(active|indulge|legging|leggings|tights|bike short|shorts|crop|sports bra|workout|tank)/.test(txt)) {
    return 'activewear';
  }
  if (/(sherpa|coat|jacket|outerwear|rain jacket|puffer|zip espresso|zip oat milk)/.test(txt)) {
    return 'outerwear';
  }
  if (/(hooded blanket|blanket hoodie|deluxe blanket|throw blanket|lounge|loungewear|robe|faux fur robe)/.test(txt)) {
    return 'loungewear';
  }
  return '';
}

function renderDiscoverFavourites(c) {
  var wrap = document.getElementById('alohr-discover');
  var track = document.getElementById('alohr-discover-track');
  var heading = document.getElementById('alohr-discover-heading');
  if (!wrap || !track) return;

  var inCart = {};
  (c.items || []).forEach(function(item) {
    var cat = detectDiscoverCategory(item);
    if (cat) inCart[cat] = true;
  });

  var cards = DISCOVER_FAVOURITES.filter(function(card) {
    return !inCart[card.key];
  }).slice(0, 3);

  if (!cards.length) {
    wrap.style.display = 'none';
    track.innerHTML = '';
    return;
  }

  wrap.style.display = '';
  if (heading) {
    var cartCats = Object.keys(inCart);
    var adaptiveHeading = 'DISCOVER OUR OTHER COLLECTIONS';
    if (cartCats.length === 1) {
      if (cartCats[0] === 'swimwear') adaptiveHeading = 'P.S. WE DO MORE THAN SWIM 👀';
      if (cartCats[0] === 'loungewear') adaptiveHeading = 'P.S. WE DO MORE THAN LOUNGE 👀';
      if (cartCats[0] === 'outerwear') adaptiveHeading = 'P.S. WE DO MORE THAN OUTERWEAR 👀';
      if (cartCats[0] === 'activewear') adaptiveHeading = 'P.S. WE DO MORE THAN ACTIVE 👀';
    }
    heading.textContent = adaptiveHeading;
  }
  track.innerHTML = cards.map(function(card) {
    return '<a class="alohr-discover__card" href="' + card.url + '" onclick="AlohrCart.close()" aria-label="' + esc(card.cta) + '">'
      + '<span class="alohr-discover__image-wrap"><img class="alohr-discover__image" src="' + card.image + '" alt="' + esc(card.label) + '" loading="lazy"></span>'
      + '<span class="alohr-discover__cta">' + esc(card.cta) + '</span>'
      + '</a>';
  }).join('');
}

function renderSummary(c) {
  var disc = c.total_discount || 0;

  // Adjust total for priority dispatch price quirk
  // Shopify returns 100000 for this $10 product (100x inflated)
  var priorityItem = c.items && c.items.find(function(i){ return i.variant_id == PRIORITY_VARIANT_ID; });
  var displayTotal = c.total_price;
  var displaySubtotal = c.total_price;
  if (priorityItem) {
    var pp = PRIORITY_PRICES[c.currency] || PRIORITY_DEFAULT;
    displayTotal = displayTotal - priorityItem.line_price + pp.cents;
    displaySubtotal = displaySubtotal - priorityItem.line_price + pp.cents;
    if (priorityItem.total_discount) {
      disc = Math.max(0, disc - priorityItem.total_discount);
    }
  }

  // Adjust total for protection product price quirk (same 100x issue + exclude FLASH20)
  var protItem = c.items && c.items.find(function(i){ return String(i.variant_id) === String(PROTECTION_VARIANT_ID); });
  if (protItem) {
    var protP = PROTECTION_PRICES[c.currency] || PROTECTION_DEFAULT;
    displayTotal = displayTotal - protItem.line_price + protP.cents;
    displaySubtotal = displaySubtotal - protItem.line_price + protP.cents;
    if (protItem.total_discount) {
      disc = Math.max(0, disc - protItem.total_discount);
    }
  }

  // Adjust for express shipping upgrade — fix price (exclude FLASH20 discount like protection)
  var _expItem = c.items && c.items.find(function(i){
    return String(i.variant_id) === String(EXPRESS_AU_VARIANT_ID) || String(i.variant_id) === String(EXPRESS_INTL_VARIANT_ID);
  });
  if (_expItem) {
    var expP = EXPRESS_PRICES[c.currency] || EXPRESS_DEFAULT_PRICE;
    displayTotal = displayTotal - _expItem.line_price + expP.cents;
    displaySubtotal = displaySubtotal - _expItem.line_price;
    if (_expItem.total_discount) {
      disc = Math.max(0, disc - _expItem.total_discount);
    }
  }

  // Savings row removed

  var discountRow = document.getElementById('alohr-discount-row');
  var discountAmount = document.getElementById('alohr-discount-amount');
  if (discountRow && discountAmount) {
    if (disc > 0) {
      discountAmount.textContent = '-' + fmt(disc, c.currency);
      discountRow.style.display = 'flex';
    } else {
      discountRow.style.display = 'none';
    }
  }

  var subtotalEl = document.getElementById('alohr-subtotal');
  var t = THRESHOLDS[c.currency] || DEFAULT_THRESHOLD;
  var shippingUnlocked = displayTotal >= t.cents;
  var subtotalLabelEl = document.getElementById('alohr-subtotal-label');
  if (subtotalLabelEl) subtotalLabelEl.textContent = shippingUnlocked ? 'TOTAL' : 'SUBTOTAL';
  if (subtotalEl) subtotalEl.textContent = fmt(shippingUnlocked ? displayTotal : displaySubtotal, c.currency);
  var dutiesNoteEl = document.getElementById('alohr-duties-note');
  if (dutiesNoteEl) dutiesNoteEl.style.display = (c.currency === 'AUD') ? 'none' : 'block';
  var shippingFreeEl = document.getElementById('alohr-shipping-free');
  if (shippingFreeEl) {
    shippingFreeEl.style.display = shippingUnlocked ? 'flex' : 'none';
    // When unlocked, reorder: SHIPPING above TOTAL, SAVINGS below TOTAL
    var subtotalRow = subtotalLabelEl ? subtotalLabelEl.closest('.alohr-summary__subtotal') : null;
    if (shippingUnlocked && subtotalRow && subtotalRow.parentNode) {
      // SHIPPING -> DISCOUNT -> TOTAL -> duties
      subtotalRow.parentNode.insertBefore(shippingFreeEl, subtotalRow);
      if (discountRow) subtotalRow.parentNode.insertBefore(discountRow, subtotalRow);
      if (dutiesNoteEl && c.currency !== 'AUD') subtotalRow.parentNode.appendChild(dutiesNoteEl);
    } else if (!shippingUnlocked && subtotalRow && subtotalRow.parentNode) {
      // SUBTOTAL -> DISCOUNT -> SHIPPING -> duties
      subtotalRow.parentNode.insertBefore(shippingFreeEl, subtotalRow.nextSibling);
      if (discountRow) subtotalRow.parentNode.insertBefore(discountRow, subtotalRow.nextSibling);
      if (dutiesNoteEl && c.currency !== 'AUD') subtotalRow.parentNode.appendChild(dutiesNoteEl);
    }
  }
  var shippingRate = SHIPPING_FROM_RATES[c.currency] || DEFAULT_SHIPPING_FROM;
  // TODAY'S TOTAL always includes shipping when threshold not hit
  var displayTotalWithShipping = shippingUnlocked ? displayTotal : (displayTotal + shippingRate);
  var shippingEl = document.getElementById('alohr-summary-shipping');
  if (shippingEl) {
    if (shippingUnlocked) {
      shippingEl.textContent = 'FREE';
      shippingEl.style.color = '#1F6B45'; // FREE stays green
      shippingEl.style.fontSize = '1.1em'; // match TODAYS SAVINGS row size
    } else {
      shippingEl.textContent = fmt(shippingRate, c.currency);
      shippingEl.style.color = '#111111'; // paid shipping is black
      shippingEl.style.fontSize = ''; // reset to normal row size
    }
  }

  var nudgeEl = document.getElementById('alohr-shipping-nudge');
  if (nudgeEl) {
    if (shippingUnlocked) {
      nudgeEl.style.display = 'none';
      nudgeEl.textContent = '';
    } else {
      var remaining = t.cents - displayTotal;
      if (remaining < 0) remaining = 0;
      nudgeEl.innerHTML = '(<strong>Spend ' + fmt(remaining, c.currency) + '</strong> more & <strong>save</strong> <strong>$10.00</strong> on shipping)';
      nudgeEl.style.display = 'block';
    }
  }

  var dutiesRow = document.getElementById('alohr-summary-duties-row');
  if (dutiesRow) {
    dutiesRow.style.display = c.currency === 'AUD' ? 'none' : 'flex';
  }

  var totalLabelEl = document.getElementById('alohr-summary-total-label');
  if (totalLabelEl) totalLabelEl.textContent = "TODAY'S TOTAL";

  var totalEl = document.getElementById('alohr-summary-total');
  if (totalEl) {
    totalEl.textContent = fmt(displayTotalWithShipping, c.currency);
    totalEl.style.color = '#111111';
  }

  var afterpayEl = document.getElementById('alohr-afterpay-amount');
  if (afterpayEl) afterpayEl.textContent = fmt(Math.round(displayTotalWithShipping / 4), c.currency);
}

/* ── Complete Your Set ── */
var SWIMWEAR_DESIGNS_CYS = ['margot','alba','lucia','cleo','isla','esme','paloma','frankie','kendall','solana','harper','luna','norah','ivy','bronte','maia','tatum','zara','florence','remi','sadie','vienna'];
// Colours sorted longest-first so 'Checked-In Iced Chocolate' matches before 'Iced Chocolate' or 'Chocolate'
var SWIMWEAR_COLOURS_CYS = [
  'checked in iced chocolate','checked in bubblegum','checked in cherry','checked in indigo','checked in sugarplum','checked in honeycomb',
  'polka cocoa frost','polka cherry','cherry blossom','strawberry matcha',
  'iced chocolate','cocoa frost','melon sorbet','safari muse','horizon','sunset',
  'chocolate','sherbet','indigo','cherry','midnight','coastal','passionfruit','serengeti','oceana','butter'
];
function extractColourCYS(title) {
  var lower = (title || '').toLowerCase().replace(/[-_/]+/g, ' ');
  for (var i = 0; i < SWIMWEAR_COLOURS_CYS.length; i++) {
    if (lower.indexOf(SWIMWEAR_COLOURS_CYS[i]) !== -1) return SWIMWEAR_COLOURS_CYS[i];
  }
  return '';
}
function isSwimwearCYS(title) {
  var lower = title.toLowerCase();
  return SWIMWEAR_DESIGNS_CYS.some(function(d){ return lower.indexOf(d) !== -1; });
}
function isTopCYS(title) { var l = title.toLowerCase(); return l.indexOf('top') !== -1 && l.indexOf('bottom') === -1; }
function isBottomCYS(title) { var l = title.toLowerCase(); return l.indexOf('bottom') !== -1 || l.indexOf('shorts') !== -1; }
var cysTimer = null;
var cysGen = 0;
function updateCYS(c) {
  clearTimeout(cysTimer);
  cysTimer = setTimeout(function() { _doUpdateCYS(c); }, 80);
}
function _doUpdateCYS(c) {
  var cysEl = document.getElementById('alohr-cys');
  var cysList = document.getElementById('alohr-cys-list');
  if (!cysEl || !cysList) return;
  var items = c.items || [];
  var colourMap = {};
  items.forEach(function(item) {
    var title = item.product_title || item.title;
    if (!isSwimwearCYS(title)) return;
    var colour = extractColourCYS(title);
    if (!colour) return;
    if (!colourMap[colour]) colourMap[colour] = { hasTop: false, hasBottom: false };
    if (isTopCYS(title)) colourMap[colour].hasTop = true;
    if (isBottomCYS(title)) colourMap[colour].hasBottom = true;
  });
  var suggestions = [];
  Object.keys(colourMap).forEach(function(colour) {
    var pair = colourMap[colour];
    if (pair.hasTop && !pair.hasBottom) suggestions.push({ colour: colour, lookingFor: 'bottom' });
    if (pair.hasBottom && !pair.hasTop) suggestions.push({ colour: colour, lookingFor: 'top' });
  });
  if (!suggestions.length) { cysEl.style.display = 'none'; cysList.innerHTML = ''; return; }
  cysEl.style.display = '';
  cysList.innerHTML = '';
  var myGen = ++cysGen;
  var renderedHandles = {};
  suggestions.forEach(function(sug) {
    var searchTerm = encodeURIComponent(sug.colour + ' ' + sug.lookingFor);
    fetch('/search/suggest.json?q=' + searchTerm + '&resources[type]=product&resources[limit]=10')
      .then(function(r){ return r.json(); })
      .then(function(d){
        if (myGen !== cysGen) return;
        var products = (d.resources && d.resources.results && d.resources.results.products) || [];
        products.filter(function(p){
          return isSwimwearCYS(p.title)
            && (sug.lookingFor === 'bottom' ? isBottomCYS(p.title) : isTopCYS(p.title))
            && extractColourCYS(p.title) === sug.colour;
        }).forEach(function(p){
          if (myGen !== cysGen) return;
          if (renderedHandles[p.handle]) return;
          renderedHandles[p.handle] = true;
          var imgUrl = p.featured_image && p.featured_image.url ? p.featured_image.url + '&width=280' : '';
          var card = document.createElement('div');
          card.className = 'alohr-cys__card';
          card.innerHTML = '<a href="/products/'+esc(p.handle)+'" class="alohr-cys__link"><img class="alohr-cys__img" src="'+esc(imgUrl)+'" alt="'+esc(p.title)+'" loading="lazy"></a>'
            + '<a href="/products/'+esc(p.handle)+'" class="alohr-cys__link alohr-cys__name-link"><div class="alohr-cys__name">'+esc(p.title)+'</div></a>'
            + '<div class="alohr-cys__price">'+fmt(p.price_min * 100, c.currency)+'</div>'
            + '<div class="alohr-cys__sizes" data-cys-sizes></div>';
          cysList.appendChild(card);
          fetch('/products/'+p.handle+'.js').then(function(r){ return r.json(); }).then(function(prod){
            var szWrap = card.querySelector('[data-cys-sizes]');
            prod.variants.forEach(function(v){
              var btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'alohr-cys__sz'+(v.available?'':' alohr-cys__sz--oos');
              btn.textContent = v.title;
              btn.dataset.vid = v.id;
              if (!v.available) btn.disabled = true;
              btn.addEventListener('click', function(){
                if (btn.disabled || btn.dataset.adding === '1') return;
                btn.dataset.adding = '1';
                var origText = btn.textContent;
                szWrap.querySelectorAll('.alohr-cys__sz').forEach(function(b){ b.classList.remove('alohr-cys__sz--selected'); });
                btn.classList.add('alohr-cys__sz--selected');
                fetch('/cart/add.js', { method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:v.id,quantity:1}]}) })
                  .then(function(){ return fetchCart().then(render); })
                  .then(function(){
                    btn.textContent='✓'; btn.style.background='#FB9EFF'; btn.style.borderColor='#FB9EFF'; btn.style.color='#fff';
                    setTimeout(function(){ btn.textContent=origText; btn.style.background=''; btn.style.borderColor=''; btn.style.color=''; btn.classList.remove('alohr-cys__sz--selected'); btn.dataset.adding=''; }, 1200);
                  }).catch(function(){ btn.textContent=origText; btn.dataset.adding=''; });
              });
              szWrap.appendChild(btn);
            });
          }).catch(function(){});
        });
      }).catch(function(){});
  });
}

/* ── Main Render ── */

function render(c) {
  cart = c;
  updateBadge(c.item_count);
  updateShipping(c);
  // Set priority price label from cart currency
  var priceEl = document.getElementById('alohr-priority-price');
  if (priceEl) {
    var pp = PRIORITY_PRICES[c.currency] || PRIORITY_DEFAULT;
    priceEl.textContent = '+ ' + pp.display;
  }

  var body = document.getElementById('alohr-cart-body');
  var empty = document.getElementById('alohr-empty');
  var footer = document.getElementById('alohr-cart-footer');

  if (!c.items.length || c.items.every(function(i){ return i.variant_id == PRIORITY_VARIANT_ID || String(i.variant_id) === String(PROTECTION_VARIANT_ID) || String(i.variant_id) === String(EXPRESS_AU_VARIANT_ID) || String(i.variant_id) === String(EXPRESS_INTL_VARIANT_ID); })) {
    if (body) body.style.display = 'none';
    if (empty) empty.style.display = 'flex';
    if (footer) footer.style.display = 'none';
    return;
  }
  if (body) body.style.display = 'flex';
  if (empty) empty.style.display = 'none';
  if (footer) footer.style.display = 'block';

  renderItems(c);
  renderSummary(c);
  renderDelivery(c);
  renderDiscoverFavourites(c);
  updatePointsEarn(c);
  updateCYS(c);
  updateTrustLines(c);

  // Sync priority checkbox
  var chk = document.getElementById('alohr-priority-check');
  if (chk) {
    var inCart = c.items.some(function(i){ return i.variant_id == PRIORITY_VARIANT_ID; });
    chk.checked = inCart;
    if (inCart) {
      var pItem = c.items.find(function(i){ return i.variant_id == PRIORITY_VARIANT_ID; });
      if (pItem) priorityKey = pItem.key;
    }
  }

  // Sync protection upsell checkbox — AUD only
  var protEl = document.getElementById('alohr-protection');
  var protChk = document.getElementById('alohr-protection-check');
  var protPriceEl = document.getElementById('alohr-protection-price');
  var protInCart = c.items.some(function(i){ return String(i.variant_id) === String(PROTECTION_VARIANT_ID); });
  if (protEl) protEl.style.display = (c.currency === 'AUD') ? '' : 'none';
  // Auto-remove protection product if customer is outside AUD
  if (c.currency !== 'AUD' && protInCart) {
    var protFound = c.items.find(function(i){ return String(i.variant_id) === String(PROTECTION_VARIANT_ID); });
    if (protFound) updateItem(protFound.key, 0);
  }
  if (protChk) { protChk.checked = protInCart; protChk.disabled = false; }
  if (protPriceEl) {
    var pp = PROTECTION_PRICES[c.currency] || PROTECTION_DEFAULT;
    protPriceEl.textContent = pp.display;
  }

  fetchRecs(c.currency);

  // IGC
  if (!igcLoaded) {
    igcLoaded = true;
    var widget = document.getElementById('igc-widget');
    if (widget && widget.dataset.email) fetchIGC(widget.dataset.email);
  }
}

/* ── Recommendations ── */

function fetchRecs(currency) {
  var recsEl = document.getElementById('alohr-recs');
  if (!recsEl) return;

  var handle = '';
  try {
    handle = (recsEl.dataset && recsEl.dataset.recsCollectionHandle) ? recsEl.dataset.recsCollectionHandle : '';
  } catch(e) {}
  handle = (handle || '').trim();

  var limit = CART_RECS_DEFAULT_LIMIT;

  function renderCards(products) {
    var listEl = document.getElementById('alohr-recs-list');
    var html = '';
    (products || []).slice(0, limit).forEach(function(p) {
      var variants = p.variants || [];
      if (!variants || !variants.length) return;
      var v = (variants && variants.find) ? (variants.find(function(vr){ return vr && vr.available; }) || variants[0] || {}) : (variants[0] || {});
      if (!v || !v.id) return;

      var imgSrc = '';
      if (p.images && p.images.length) {
        imgSrc = p.images[0];
        if (imgSrc && typeof imgSrc !== 'string' && imgSrc.src) imgSrc = imgSrc.src;
      } else if (p.image && p.image.src) {
        imgSrc = p.image.src;
      } else if (p.image) {
        imgSrc = p.image;
      }

      var priceCents = v.price != null ? parsePrice(v.price) : 0;
      var compareCents = v.compare_at_price != null ? parsePrice(v.compare_at_price) : null;
      var discounted = flashPrice(priceCents);
      var wasBase = (typeof compareCents === 'number' && compareCents > priceCents) ? compareCents : null;

      var hasRealVariants = (variants || []).length > 1 && variants[0] && variants[0].title !== 'Default Title';
      var recHandle = p.handle || (p.id ? String(p.id) : '');
      var recUrl = p.url || ('/products/' + encodeURIComponent(p.handle || ''));

      html += '<div class="alohr-rec" data-rec-handle="' + esc(String(recHandle)) + '">';
      if (imgSrc) html += '<a href="' + recUrl + '" onclick="AlohrCart.close()"><img class="alohr-rec__img" src="' + esc(String(imgSrc)) + '" alt="' + esc(p.title) + '" loading="lazy"></a>';
      html += '<a href="' + recUrl + '" class="alohr-rec__title" onclick="AlohrCart.close()">' + esc(p.title) + '</a>';
      html += '<div class="alohr-rec__price" data-rec-price><span class="alohr-rec__price-now" data-rec-price-now>' + fmt(discounted, currency) + '</span><span class="alohr-rec__price-was" data-rec-price-was' + ((typeof wasBase === 'number' && wasBase > discounted) ? '' : ' style="display:none;"') + '>' + (typeof wasBase === 'number' ? fmt(wasBase, currency) : '') + '</span></div>';
      if (hasRealVariants) {
        html += '<div class="alohr-rec__sizes" data-rec-sizes>';
        html += (variants || []).map(function(vr) {
          var avail = vr && vr.available !== false;
          return '<button type="button" class="alohr-rec__sz' + (avail ? '' : ' alohr-rec__sz--oos') + '" data-action="add-rec-sz" data-vid="' + esc(String(vr.id)) + '"' + (avail ? '' : ' disabled') + '>' + esc(vr.title) + '</button>';
        }).join('');
        html += '</div>';
      } else {
        html += '<div class="alohr-rec__sizes" data-rec-sizes>';
        html += '<button type="button" class="alohr-rec__sz" data-action="add-rec-sz" data-vid="' + v.id + '">ADD</button>';
        html += '</div>';
      }
      html += '</div>';
    });
    if (listEl) listEl.innerHTML = html;

    // Native <select> handles its own open/close/pick on all platforms.
    // A single delegated 'change' listener (bound once, below) updates state.
    recsEl.style.display = '';
  }

  if (handle) {
    fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + limit + '&sort_by=manual', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(data) {
        var products = (data && data.products) ? data.products : [];
        if (!products || !products.length) {
          recsEl.style.display = 'none';
          return;
        }
        renderCards(products);
      })
      .catch(function() { recsEl.style.display = 'none'; });
    return;
  }

  // Fallback (older hard-coded list)
  Promise.all(LAST_CHANCE_PRODUCTS.map(function(base) {
    return fetch('/products/' + base.handle + '.json', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(data) {
        var product = data.product || data;
        return {
          id: base.id,
          title: base.title,
          handle: base.handle,
          images: base.image ? [base.image] : [],
          url: base.url,
          variants: product.variants || []
        };
      })
      .catch(function() {
        return {
          id: base.id,
          title: base.title,
          handle: base.handle,
          images: base.image ? [base.image] : [],
          url: base.url,
          variants: []
        };
      });
  }))
    .then(function(products) { renderCards(products || []); })
    .catch(function() { recsEl.style.display = ''; });
}

/* ── IGC Logged In ── */

function fetchIGC(email) {
  var widget = document.getElementById('igc-widget');
  if (!widget) return;

  fetch(LOYALTY_API + '/' + encodeURIComponent(email), { credentials: 'omit' })
    .then(function(r){ return r.json(); })
    .then(function(d) {
      if (!d || !d.enrolled) return;
      var tier = (d.tier || 'it_girl');
      var tierIcon = tier === 'icon' ? '\u2726\u2726\u2726' : tier === 'main_character' ? '\u2726\u2726' : '\u2726';
      var pts = d.points_balance || 0;
      var cash = d.cash_value || 0;
      var cashDisplay = '$' + (typeof cash === 'number' ? cash.toFixed(2) : String(cash).replace('$',''));
      var rateMap = { it_girl: '$7.50', main_character: '$10.00', icon: '$12.50' };
      var tierRate = rateMap[d.tier] || '$7.50';
      var html = '';

      if (pts >= 1) {
        html += '<div class="alohr-igc__result-card">';
        html += '<div class="alohr-igc__result-header">';
        html += '<div class="alohr-igc__result-tier"><span class="alohr-igc__result-tier-sparkle">\u2726</span><span class="alohr-igc__result-tier-divider"></span><span class="alohr-igc__result-tier-label">' + esc(d.tier_label || 'It Girl') + '</span></div>';
        html += '</div>';
        html += '<div class="alohr-igc__result-body">';
        html += '<div class="alohr-igc__result-left">';
        html += '<div class="alohr-igc__result-pts-wrap"><span class="alohr-igc__result-sparkle-tl">\u2726</span><span class="alohr-igc__result-pts">' + pts + '</span><span class="alohr-igc__result-sparkle-br">\u2726</span></div>';
        html += '<div class="alohr-igc__result-pts-label">POINTS</div>';
        html += '</div>';
        html += '<div class="alohr-igc__result-mid-divider"></div>';
        html += '<div class="alohr-igc__result-right">';
        html += '<div class="alohr-igc__result-gift-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="10" width="18" height="11" rx="1" stroke="#E070F0" stroke-width="1.5"/><rect x="1" y="6" width="22" height="4" rx="1" stroke="#E070F0" stroke-width="1.5"/><path d="M12 6V21" stroke="#E070F0" stroke-width="1.5"/><path d="M12 6C12 6 9 3 7 4C5 5 6 8 8 8C10 8 12 6 12 6Z" stroke="#E070F0" stroke-width="1.5" stroke-linejoin="round"/><path d="M12 6C12 6 15 3 17 4C19 5 18 8 16 8C14 8 12 6 12 6Z" stroke="#E070F0" stroke-width="1.5" stroke-linejoin="round"/></svg></div>';
        html += '<div class="alohr-igc__result-value">= ' + esc(cashDisplay) + '</div>';
        html += '<div class="alohr-igc__result-value-label">GIFT CARD VALUE</div>';
        html += '</div>';
        html += '</div>';
        html += '<button class="alohr-igc__redeem-full-btn" data-email="' + esc(email) + '" data-points="' + pts + '"><span class="alohr-igc__redeem-sparkle">\u2726</span>REDEEM ' + pts + ' POINTS \u2192 ' + esc(cashDisplay) + ' GIFT CARD</button>';
        html += '<div class="alohr-igc__redeem-footer"><hr class="alohr-igc__redeem-hr"><span class="alohr-igc__redeem-envelope">\u2709</span><hr class="alohr-igc__redeem-hr"></div>';
        html += '<p class="alohr-igc__redeem-note">Gift card code will be emailed to you</p>';
        html += '</div>';
      } else {
        html += '<div class="alohr-igc__result-card">';
        html += '<div class="alohr-igc__result-header">';
        html += '<div class="alohr-igc__result-tier">';
        html += '<span class="alohr-igc__result-tier-sparkle">' + tierIcon + '</span>';
        html += '<span class="alohr-igc__result-tier-divider"></span>';
        html += '<span class="alohr-igc__result-tier-label">' + esc(d.tier_label || 'It Girl') + '</span>';
        html += '</div>';
        html += '</div>';
        html += '<div class="alohr-igc__result-body">';
        html += '<div class="alohr-igc__result-left">';
        html += '<div class="alohr-igc__result-pts-wrap"><span class="alohr-igc__result-sparkle-tl">\u2726</span><span class="alohr-igc__result-pts">' + pts + '</span><span class="alohr-igc__result-sparkle-br">\u2726</span></div>';
        html += '<div class="alohr-igc__result-pts-label">POINTS</div>';
        html += '</div>';
        html += '<div class="alohr-igc__result-mid-divider"></div>';
        html += '<div class="alohr-igc__result-right">';
        html += '<div class="alohr-igc__result-gift-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="10" width="18" height="11" rx="1" stroke="#E070F0" stroke-width="1.5"/><rect x="1" y="6" width="22" height="4" rx="1" stroke="#E070F0" stroke-width="1.5"/><path d="M12 6V21" stroke="#E070F0" stroke-width="1.5"/><path d="M12 6C12 6 9 3 7 4C5 5 6 8 8 8C10 8 12 6 12 6Z" stroke="#E070F0" stroke-width="1.5" stroke-linejoin="round"/><path d="M12 6C12 6 15 3 17 4C19 5 18 8 16 8C14 8 12 6 12 6Z" stroke="#E070F0" stroke-width="1.5" stroke-linejoin="round"/></svg></div>';
        html += '<div class="alohr-igc__result-value-label">GIFT CARD</div>';
        html += '</div>';
        html += '</div>';
        html += '<div class="alohr-igc__result-value">Keep earning \u2014 100 points = ' + tierRate + ' gift card</div>';
        html += '<a href="/pages/my-rewards" class="alohr-igc__redeem-btn" style="margin-top:10px;">View My Rewards \u2192</a>';
        html += '</div>';
      }
      widget.innerHTML = html;
    })
    .catch(function(){});
}

/* ── IGC Guest Lookup ── */

function getGuestFormHTML() {
  var s = window.alohrCartStrings || {};
  return ''
    + '<p class="alohr-igc__guest-heading">' + (s.checkPointsBalance || 'Check your points balance') + '</p>'
    + '<p class="alohr-igc__guest-text">' + (s.alreadyMember || 'Already a member? Enter your email to see your balance instantly.') + '</p>'
    + '<div class="alohr-igc__input-row">'
    + '<input type="email" id="igc-email-input" class="alohr-igc__input" placeholder="' + (s.emailPlaceholder || 'your@email.com') + '" autocomplete="email" onkeydown="if(event.keyCode===13)AlohrCart.lookupPoints()">'
    + '<button class="alohr-igc__check-btn" onclick="AlohrCart.lookupPoints()">' + (s.checkBtn || 'CHECK') + '</button>'
    + '</div>'
    + '<div id="igc-lookup-result" class="alohr-igc__result"></div>'
    + '<p class="alohr-igc__join-note">' + (s.joinNote || "Not a member yet? You're in automatically after your first purchase ✨") + '</p>';
}

function resetIGC() {
  var guest = document.getElementById('igc-guest');
  if (guest) guest.innerHTML = getGuestFormHTML();
}

function redeemPoints(email, points) {
  var btn = document.querySelector('.alohr-igc__redeem-full-btn');
  if (!btn) return;
  btn.disabled = true;
  btn.textContent = (window.alohrCartStrings&&window.alohrCartStrings.redeeming||'REDEEMING...');

  fetch(LOYALTY_REDEEM, {
    method: 'POST', credentials: 'omit',
    headers: { 'Content-Type': 'application/json', 'X-Loyalty-Secret': 'alohra_igc_2026_xK9mP3qR7nL4' },
    body: JSON.stringify({ email: email, points_to_redeem: parseInt(points, 10) })
  })
    .then(function(r){ return r.json(); })
    .then(function(d) {
      if (d.error) throw new Error(d.error);
      var guest = document.getElementById('igc-guest') || document.getElementById('igc-widget');
      if (!guest) return;
      guest.innerHTML = '<div class="alohr-igc__gift-card">'
        + '<p class="alohr-igc__gift-card-title">\u2713 Gift Card Created!</p>'
        + '<p class="alohr-igc__gift-card-note">Your voucher code has been sent to your email \u2014 check your inbox! Apply it at checkout.</p>'
        + '<p class="alohr-igc__gift-card-remaining">New balance: ' + d.remaining_balance + ' pts</p>'
        + '</div>'
        + '<button class="alohr-igc__result-reset" onclick="AlohrCart.resetIGC()">Check another email \u00d7</button>';
    })
    .catch(function(e) {
      btn.disabled = false;
      btn.textContent = (window.alohrCartStrings&&window.alohrCartStrings.redeem||'REDEEM')+' ' + points + ' POINTS';
      var note = document.querySelector('.alohr-igc__redeem-note');
      if (note) { note.textContent = e.message || (window.alohrCartStrings&&window.alohrCartStrings.somethingWrong||'Something went wrong. Try again.'); note.style.color = '#D04070'; }
    });
}

function lookupPoints() {
  var input = document.getElementById('igc-email-input');
  var result = document.getElementById('igc-lookup-result');
  if (!input || !result) return;

  var email = input.value.trim();
  if (!email) { result.textContent = (window.alohrCartStrings&&window.alohrCartStrings.enterEmail||'Please enter your email.'); return; }

  result.textContent = (window.alohrCartStrings&&window.alohrCartStrings.lookingUp||'Looking up...');
  fetch(LOYALTY_API + '/' + encodeURIComponent(email), { credentials: 'omit' })
    .then(function(r){ return r.json(); })
    .then(function(d) {
      if (!d || !d.enrolled) {
        result.innerHTML = 'No account found. Not a member yet? You\'re in automatically after your first purchase ✨';
        return;
      }

      var guest = document.getElementById('igc-guest');
      if (!guest) return;
      var tier = (d.tier || 'it_girl');
      var tierIcon = tier === 'icon' ? '\u2726\u2726\u2726' : tier === 'main_character' ? '\u2726\u2726' : '\u2726';
      var pts = d.points_balance || 0;
      var cash = d.cash_value || 0;
      var html = '';

      /* Ensure cash has $ prefix */
      var cashDisplay = '$' + (typeof cash === 'number' ? cash.toFixed(2) : String(cash).replace('$',''));

      var rateMap = { it_girl: '$7.50', main_character: '$10.00', icon: '$12.50' };
      var tierRate = rateMap[d.tier] || '$7.50';
      if (pts >= 1) {
        html += '<div class="alohr-igc__result-card">';
        html += '<div class="alohr-igc__result-header">';
        html += '<div class="alohr-igc__result-tier"><span class="alohr-igc__result-tier-sparkle">\u2726</span><span class="alohr-igc__result-tier-divider"></span><span class="alohr-igc__result-tier-label">' + esc(d.tier_label || 'It Girl') + '</span></div>';
        html += '<button class="alohr-igc__result-close" onclick="AlohrCart.resetIGC()">\u00d7</button>';
        html += '</div>';
        html += '<div class="alohr-igc__result-body">';
        html += '<div class="alohr-igc__result-left">';
        html += '<div class="alohr-igc__result-pts-wrap"><span class="alohr-igc__result-sparkle-tl">\u2726</span><span class="alohr-igc__result-pts">' + pts + '</span><span class="alohr-igc__result-sparkle-br">\u2726</span></div>';
        html += '<div class="alohr-igc__result-pts-label">POINTS</div>';
        html += '</div>';
        html += '<div class="alohr-igc__result-mid-divider"></div>';
        html += '<div class="alohr-igc__result-right">';
        html += '<div class="alohr-igc__result-gift-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="10" width="18" height="11" rx="1" stroke="#E070F0" stroke-width="1.5"/><rect x="1" y="6" width="22" height="4" rx="1" stroke="#E070F0" stroke-width="1.5"/><path d="M12 6V21" stroke="#E070F0" stroke-width="1.5"/><path d="M12 6C12 6 9 3 7 4C5 5 6 8 8 8C10 8 12 6 12 6Z" stroke="#E070F0" stroke-width="1.5" stroke-linejoin="round"/><path d="M12 6C12 6 15 3 17 4C19 5 18 8 16 8C14 8 12 6 12 6Z" stroke="#E070F0" stroke-width="1.5" stroke-linejoin="round"/></svg></div>';
        html += '<div class="alohr-igc__result-value">= ' + esc(cashDisplay) + '</div>';
        html += '<div class="alohr-igc__result-value-label">GIFT CARD VALUE</div>';
        html += '</div>';
        html += '</div>';
        html += '<button class="alohr-igc__redeem-full-btn" data-email="' + esc(email) + '" data-points="' + pts + '"><span class="alohr-igc__redeem-sparkle">\u2726</span>REDEEM ' + pts + ' POINTS \u2192 ' + esc(cashDisplay) + ' GIFT CARD</button>';
        html += '<div class="alohr-igc__redeem-footer"><hr class="alohr-igc__redeem-hr"><span class="alohr-igc__redeem-envelope">\u2709</span><hr class="alohr-igc__redeem-hr"></div>';
        html += '<p class="alohr-igc__redeem-note">Gift card code will be emailed to you</p>';
        html += '</div>';
      } else {
        html += '<div class="alohr-igc__result-card">';
        // Header: tier + close
        html += '<div class="alohr-igc__result-header">';
        html += '<div class="alohr-igc__result-tier">';
        html += '<span class="alohr-igc__result-tier-sparkle">' + tierIcon + '</span>';
        html += '<span class="alohr-igc__result-tier-divider"></span>';
        html += '<span class="alohr-igc__result-tier-label">' + esc(d.tier_label || 'It Girl') + '</span>';
        html += '</div>';
        html += '</div>';
        // Body: big points left, gift icon right
        html += '<div class="alohr-igc__result-body">';
        html += '<div class="alohr-igc__result-left">';
        html += '<div class="alohr-igc__result-pts-wrap"><span class="alohr-igc__result-sparkle-tl">\u2726</span><span class="alohr-igc__result-pts">' + pts + '</span><span class="alohr-igc__result-sparkle-br">\u2726</span></div>';
        html += '<div class="alohr-igc__result-pts-label">POINTS</div>';
        html += '</div>';
        html += '<div class="alohr-igc__result-mid-divider"></div>';
        html += '<div class="alohr-igc__result-right">';
        html += '<div class="alohr-igc__result-gift-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="10" width="18" height="11" rx="1" stroke="#E070F0" stroke-width="1.5"/><rect x="1" y="6" width="22" height="4" rx="1" stroke="#E070F0" stroke-width="1.5"/><path d="M12 6V21" stroke="#E070F0" stroke-width="1.5"/><path d="M12 6C12 6 9 3 7 4C5 5 6 8 8 8C10 8 12 6 12 6Z" stroke="#E070F0" stroke-width="1.5" stroke-linejoin="round"/><path d="M12 6C12 6 15 3 17 4C19 5 18 8 16 8C14 8 12 6 12 6Z" stroke="#E070F0" stroke-width="1.5" stroke-linejoin="round"/></svg></div>';
        html += '<div class="alohr-igc__result-value-label">GIFT CARD</div>';
        html += '</div>';
        html += '</div>';
        // Keep earning message
        html += '<div class="alohr-igc__result-value">Keep earning \u2014 100 points = ' + tierRate + ' gift card</div>';
        // Reset button at bottom
        html += '<button class="alohr-igc__result-reset" onclick="AlohrCart.resetIGC()">Check different email \u00d7</button>';
        html += '</div>';
      }
      guest.innerHTML = html;
    })
    .catch(function() { result.textContent = (window.alohrCartStrings&&window.alohrCartStrings.somethingWrong||'Something went wrong. Try again.'); });
}

/* ── Priority Dispatch ── */

function togglePriority(checked) {
  if (checked) {
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: PRIORITY_VARIANT_ID, quantity: 1 }] })
    }).then(function(r){ return r.json(); })
      .then(function(){ return fetchCart().then(render); });
  } else {
    var key = priorityKey;
    if (!key && cart && cart.items) {
      var found = cart.items.find(function(i){ return i.variant_id == PRIORITY_VARIANT_ID; });
      if (found) key = found.key;
    }
    if (key) {
      priorityKey = null;
      fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function(){ return fetchCart().then(render); });
    }
  }
}

/* ── Form Intercept ── */

function interceptForms() {
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var data = new FormData(form);
    var id = data.get('id');
    var qty = parseInt(data.get('quantity'), 10) || 1;

    if (id) {
      addItem(parseInt(id, 10), qty).then(function() { openCart('add-to-cart'); });
    }
  }, true);
}

/* ── Init ── */

function init() {
  var cartBtn = document.getElementById('alohr-cart-btn');
  if (cartBtn) cartBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopImmediatePropagation(); openCart(); }, true);

  var closeBtn = document.querySelector('.alohr-cart-header__close');
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  var checkoutBtn = document.getElementById('alohr-checkout-btn');
  if (checkoutBtn) checkoutBtn.addEventListener('click', function() {
    checkoutBtn.textContent = 'PROCESSING...';
    checkoutBtn.style.opacity = '0.75';
    checkoutBtn.style.pointerEvents = 'none';
  });
  function resetCheckoutButton() {
    var checkoutBtn = document.getElementById('alohr-checkout-btn');
    if (checkoutBtn) {
      checkoutBtn.textContent = 'CHECKOUT';
      checkoutBtn.disabled = false;
      checkoutBtn.style.opacity = '';
      checkoutBtn.style.pointerEvents = '';
    }
  }
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) resetCheckoutButton();
  });
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible') resetCheckoutButton();
  });

  var backdrop = document.getElementById('alohr-cart-backdrop');
  if (backdrop) backdrop.addEventListener('click', closeCart);

  var itemsEl = document.getElementById('alohr-cart-items');
  if (itemsEl) {
    itemsEl.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-action]');
      if (!btn || btn.disabled) return;
      var action = btn.dataset.action;
      var key = btn.dataset.key;
      var qty = parseInt(btn.dataset.qty, 10);
      if ((action === 'decrease' || action === 'increase' || action === 'remove') && key) {
        btn.disabled = true;
        updateItem(key, qty).then(function(){ btn.disabled = false; });
      }
    });
  }

  var cartOffersEl = document.getElementById('alohr-cart-offers-overlay');
  if (cartOffersEl) {
    cartOffersEl.addEventListener('click', function(e) {
      var dismiss = e.target.closest('[data-cart-offers-dismiss]');
      if (dismiss) {
        e.preventDefault();
        closeCartOffers(true);
        return;
      }

      var card = e.target.closest('[data-cart-offer-card]');
      if (!card) return;

      var currency = (cart && cart.currency) ? cart.currency : 'USD';
      var sizesEl = card.querySelector('[data-offer-sizes]');
      var addBtn = card.querySelector('[data-cart-offer-add]');

      var cancelBtn = e.target.closest('[data-offer-cancel]');
      if (cancelBtn) {
        e.preventDefault();
        e.stopPropagation();
        card.dataset.selectedVid = '';
        if (sizesEl) sizesEl.querySelectorAll('[data-offer-pick-size]').forEach(function(b){ b.classList.remove('is-selected'); });
        if (addBtn) addBtn.disabled = true;
        return;
      }

      var sizeBtn = e.target.closest('[data-offer-pick-size]');
      if (sizeBtn) {
        e.preventDefault();
        e.stopPropagation();
        var vidPick = parseInt(sizeBtn.dataset.vid, 10);
        if (!vidPick || sizeBtn.disabled) return;
        card.dataset.selectedVid = String(vidPick);

        if (sizesEl) sizesEl.querySelectorAll('[data-offer-pick-size]').forEach(function(b){ b.classList.remove('is-selected'); });
        sizeBtn.classList.add('is-selected');

        var priceC = sizeBtn.dataset.price ? parseInt(sizeBtn.dataset.price, 10) : null;
        var compareC = sizeBtn.dataset.compareAtPrice ? parseInt(sizeBtn.dataset.compareAtPrice, 10) : null;
        if (typeof priceC === 'number' && !isNaN(priceC)) setOfferCardPrice(card, currency, priceC, (typeof compareC === 'number' && !isNaN(compareC)) ? compareC : null);

        if (addBtn) addBtn.disabled = false;
        return;
      }

      var addBtnClick = e.target.closest('[data-cart-offer-add]');
      if (!addBtnClick || addBtnClick.disabled) return;
      e.preventDefault();
      e.stopPropagation();

      if (card.dataset.requiresSize === '1') {
        var selected = parseInt(card.dataset.selectedVid || '', 10);
        if (!selected) return;
        addBtnClick.disabled = true;
        addBtnClick.textContent = 'ADDING...';
        addItem(selected, 1)
          .then(function() { closeCartOffers(false); })
          .catch(function() {
            addBtnClick.disabled = false;
            addBtnClick.textContent = (window.alohrCartStrings&&window.alohrCartStrings.addToBag||'ADD TO BAG');
          });
        return;
      }

      var vid = parseInt(addBtnClick.dataset.variantId, 10);
      if (!vid) return;
      addBtnClick.disabled = true;
      addBtnClick.textContent = 'ADDING...';
      addItem(vid, 1)
        .then(function() {
          closeCartOffers(false);
          addBtnClick.disabled = false;
          addBtnClick.textContent = (window.alohrCartStrings&&window.alohrCartStrings.addToBag||'ADD TO BAG');
        })
        .catch(function() {
          addBtnClick.disabled = false;
          addBtnClick.textContent = (window.alohrCartStrings&&window.alohrCartStrings.addToBag||'ADD TO BAG');
        });
    });
  }

  var _lastRecAdd = 0;
  var recsListEl = document.getElementById('alohr-recs');
  if (recsListEl) {
    recsListEl.addEventListener('click', function(e) {
      e.stopPropagation();
      var btn = e.target.closest('[data-action="add-rec-sz"]');
      if (!btn || btn.disabled || btn.dataset.adding === '1') return;
      e.preventDefault();
      var vid = parseInt(btn.dataset.vid, 10);
      if (!vid) return;
      var _now = Date.now();
      if (_now - _lastRecAdd < 600) return;
      _lastRecAdd = _now;
      btn.dataset.adding = '1';
      var origText = btn.textContent;
      var sizesWrap = btn.closest('[data-rec-sizes]');
      if (sizesWrap) sizesWrap.querySelectorAll('.alohr-rec__sz').forEach(function(b){ b.classList.remove('alohr-rec__sz--selected'); });
      btn.classList.add('alohr-rec__sz--selected');
      addItem(vid, 1).then(function() {
        btn.textContent = '✓';
        btn.style.background = '#FB9EFF';
        btn.style.borderColor = '#FB9EFF';
        btn.style.color = '#fff';
        setTimeout(function() {
          btn.textContent = origText;
          btn.style.background = '';
          btn.style.borderColor = '';
          btn.style.color = '';
          btn.classList.remove('alohr-rec__sz--selected');
          btn.dataset.adding = '';
        }, 1200);
      }).catch(function() {
        btn.textContent = origText;
        btn.dataset.adding = '';
      });
    });
  }

  // Protection upsell checkbox toggle — uses same pattern as priority shipping
  var protCheck = document.getElementById('alohr-protection-check');
  if (protCheck) {
    protCheck.addEventListener('click', function(e) {
      e.preventDefault();
      var chk = this;
      if (chk.dataset.busy === '1') return;
      chk.dataset.busy = '1';
      // Check current cart state, not checkbox visual
      var isInCart = cart && cart.items && cart.items.some(function(i) { return i.variant_id == PROTECTION_VARIANT_ID; });
      if (isInCart) {
        // Remove it
        var found = cart.items.find(function(i) { return i.variant_id == PROTECTION_VARIANT_ID; });
        if (found) {
          updateItem(found.key, 0).then(function() { chk.dataset.busy = ''; }).catch(function() { chk.dataset.busy = ''; });
        } else { chk.dataset.busy = ''; }
      } else {
        // Add it
        addItem(PROTECTION_VARIANT_ID, 1).then(function() { chk.dataset.busy = ''; }).catch(function() { chk.dataset.busy = ''; });
      }
    });
  }

  // Express shipping upgrade checkbox
  // Express checkout listener removed — now display-only, true);

  interceptForms();

  // IGC redeem button delegation
  var igcEl = document.getElementById('alohr-igc');
  if (igcEl) {
    igcEl.addEventListener('click', function(e) {
      var btn = e.target.closest('.alohr-igc__redeem-full-btn');
      if (!btn || btn.disabled) return;
      redeemPoints(btn.dataset.email, btn.dataset.points);
    });
  }

  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeCart(); });
  fetchCart().then(function(c){ updateBadge(c.item_count); });
}

/* ── Public API ── */

window.AlohrCart = {
  toggleIGC: function(forceOpen) {
    var tab = document.getElementById('alohr-igc-tab');
    var body = document.getElementById('alohr-igc-body');
    if (!tab || !body) return;
    var isOpen = tab.getAttribute('aria-expanded') === 'true';
    if (forceOpen === true) isOpen = false; // force open
    if (isOpen) {
      tab.setAttribute('aria-expanded', 'false');
      body.classList.remove('is-open');
    } else {
      tab.setAttribute('aria-expanded', 'true');
      body.classList.add('is-open');
    }
  },
  open: openCart,
  close: closeCart,
  openCartOffers: openCartOffers,
  closeCartOffers: function() { closeCartOffers(true); },
  updateItem: updateItem,
  addItem: addItem,
  lookupPoints: lookupPoints,
  togglePriority: togglePriority,
  resetIGC: resetIGC,
  redeemPoints: redeemPoints
};

/* ── Boot ── */

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}


/* ── Scarcity Banner ── */
(function() {
  var MESSAGES = [
    'SELLING FAST - SECURE YOURS NOW'
  ];
  var idx = Math.floor(Math.random() * MESSAGES.length);
  var el = null;
  var timer = null;
  function tick() {
    if (!el) el = document.getElementById('alohr-scarcity-msg');
    if (!el) return;
    el.classList.remove('is-visible');
    setTimeout(function() {
      el.textContent = MESSAGES[idx % MESSAGES.length];
      idx++;
      el.classList.add('is-visible');
    }, 300);
  }
  function startScarcity() {
    if (timer) return;
    el = document.getElementById('alohr-scarcity-msg');
    if (!el) return;
    tick();
    timer = setInterval(tick, 10000);
  }
  function stopScarcity() { clearInterval(timer); timer = null; }
  // Hook into cart open/close
  document.addEventListener('DOMContentLoaded', function() {
    var origOpen = window.AlohrCart && window.AlohrCart.open;
    var origClose = window.AlohrCart && window.AlohrCart.close;
    if (window.AlohrCart) {
      window.AlohrCart.open = function() { if (origOpen) origOpen.apply(this, arguments); startScarcity(); };
      window.AlohrCart.close = function() { if (origClose) origClose.apply(this, arguments); stopScarcity(); };
    }
    startScarcity();
  });
})();

})();
